import {LOGIN_STORE, LOGOUT_STORE} from '../actions'
import axios from 'axios';

let baseURL = "/recuom",
    publicUrl = "/recuom/client/build";

if(window.location.host.indexOf('localhost') != -1){
    baseURL = "http://localhost/recuom";
    publicUrl = "";
}

const initialState = {
    isLoggedIn: false,
    user: {},
    publicUrl,
    client: axios.create({
        baseURL,
        headers : {
            "Content-Type": 'application/json'
        }
    }),
    keycloak: null
}

export default (state = initialState, action = {})=>{

    switch (action.type) {
        case LOGIN_STORE: {
            const token = action.user.token,
                    keycloak = action.user.keycloak;

            delete action.user.token;
            delete action.user.keycloak;

            return {
                ...state, 
                isLoggedIn:true,
                user: action.user,
                keycloak:keycloak,
                client: action.user.client
            }
        }

        case LOGOUT_STORE : {
            if(state.keycloak) state.keycloak.logout();
            return {
                ...state,
                isLoggedIn: false,
                user: {},
                keycloak: null,
                client:axios.create({
                    baseURL,
                    headers : {
                        "Content-Type": 'application/json'
                    }
                })
            }
        }
    
        default:
           return state;
    }
}